import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { StrategyTemplateProto } from "../proto/generated/strategy"

export type StrategyTemplateStateType = {
    strategies: StrategyTemplateProto[]
    openDialog: boolean
    editId: string | undefined
}

export const initialState: StrategyTemplateStateType = {
    strategies: [],
    openDialog: false,
    editId: undefined
}

const strategyTemplateSlice = createSlice({
    name: 'strategyTemplateSlice',
    initialState,
    reducers: {
        setStrategyTemplates(state, action: PayloadAction<StrategyTemplateProto[]>) {
            state.strategies = action.payload
            return state
        },
        addOrUpdateStrategy(state, action: PayloadAction<StrategyTemplateProto>) {
            const newStrategies = [...state.strategies]
            const index = newStrategies.findIndex(strategy=>strategy.id===action.payload.id)
            if(index!==-1) {
                newStrategies[index] = action.payload
            } else {
                newStrategies.push(action.payload)
            }
            state.strategies = newStrategies
            return state
        },
        setOpenStrategyTemplateDialog(state, action: PayloadAction<boolean>) {
            return {
                ...state,
                editId: action.payload ? state.editId : undefined,
                openDialog: action.payload
            }
        },
        removeStrategyTemplate(state, action: PayloadAction<string>) {
            const newStrategies = [...state.strategies].filter(s=>s.id!==action.payload)
            state.strategies = newStrategies
            return state
        },
        setStrategyTemplateEditId(state, action: PayloadAction<string>) {
            state.editId = action.payload
            return state
        }
    }
})

const { actions, reducer } = strategyTemplateSlice

export const { setStrategyTemplates, addOrUpdateStrategy, setOpenStrategyTemplateDialog, removeStrategyTemplate, setStrategyTemplateEditId } = actions

export default reducer